export default __webpack_public_path__ + "static/media/Moctail.0b0e6085.png";